export enum WebhookIntegrationItemType {
  WHATSAPP_PHONE = "WHATSAPP_PHONE",
  CONTACT_NAME = "CONTACT_NAME",
  ADD_TAG = "ADD_TAG",
  REMOVE_TAG = "REMOVE_TAG",
  START_ATTENDANCE = "START_ATTENDANCE",
  CLOSE_ATTENDANCE = "CLOSE_ATTENDANCE",
  SEND_MESSAGE = "SEND_MESSAGE",
  ADD_TEMPLATE = "ADD_TEMPLATE",
  ADD_CONTACT_GROUP = "ADD_CONTACT_GROUP",
  REMOVE_CONTACT_GROUP = "REMOVE_CONTACT_GROUP",
  ADD_TRIGGER_MESSAGE = "ADD_TRIGGER_MESSAGE",
  CREATE_OPPORTUNITY = "CREATE_OPPORTUNITY",
  TRANSFER_ATTENDANCE = "TRANSFER_ATTENDANCE",
  CREATE_TRACKING = "CREATE_TRACKING",
  ORIGIN_LEAD = "ORIGIN_LEAD"
}

export enum WebhookIntegrationItemTypeTranslate {
  WHATSAPP_PHONE = "Telefone Whatsapp",
  CONTACT_NAME = "Adicionar/Atualizar Nome do Contato",
  ADD_TAG = "Adicionar Etiqueta",
  REMOVE_TAG = "Remover Etiqueta",
  START_ATTENDANCE = "Iniciar Atendimento",
  CLOSE_ATTENDANCE = "Encerrar Atendimento",
  SEND_MESSAGE = "Enviar Mensagem",
  ADD_TEMPLATE = "Adicionar Template",
  ADD_CONTACT_GROUP = "Adicionar grupo de contato",
  REMOVE_CONTACT_GROUP = "Remover grupo de contato",
  ADD_TRIGGER_MESSAGE = "Adicionar Gatilho de Mensagem",
  CREATE_OPPORTUNITY = "Adicionar Oportunidade ao CRM",
  TRANSFER_ATTENDANCE = "Transferir Atendimento",
  CREATE_TRACKING = "Adicionar Trackeamento",
  ORIGIN_LEAD = "Adicionar Origem do Lead"
}